<template>
  <div class="w-fit max-w-full" :data-e2e="dataE2e">
    <b-label v-if="props.label" class="!mb-0">
      <span class="block text-sm text-white font-normal">{{ props.label }}</span>
    </b-label>
    <div class="grid bg-gray-800 border border-border-cards rounded-lg p-1.5 gap-1 relative" :style="{ gridTemplateColumns: `repeat(${options.length}, 1fr)` }">
      <div
        class="absolute inset-y-1.5 bg-white rounded-md transition-all duration-300"
        :style="indicatorStyle"
      />
      <div
        v-for="(option, index) in options"
        :key="index"
        class="z-10 flex items-center justify-center text-xs font-semibold px-3 py-2.5 cursor-pointer transition-colors duration-300 whitespace-nowrap"
        :class="selectedIndex === index ? 'text-gray-900' : 'text-gray-300'"
        @click="selectOption(index)"
        :data-e2e="dataE2e ? `${dataE2e}-option-${option.value}` : undefined"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { computed } from 'vue'
import BLabel from '../BLabel.vue';

const model = defineModel()
  
const props = defineProps({
  options: {
    type: Array,
    default: () => [
      { label: 'Option 1', value: 'option1' },
      { label: 'Option 2', value: 'option2' }
    ],
    validator: (options) => options.length >= 2
  },
  height: {
    type: String,
    default: '16'
  },
  label: {
    type: String,
    default: ''
  },
  dataE2e: {
    type: String,
    default: ''
  }
})
  
const emit = defineEmits(['change'])

const selectedIndex  = computed(() => {
  if (model.value !== null) {
    const index = props.options.findIndex(option => option.value === model.value)
    if (index !== -1) {
      return index
    }
  }

  return 0
})

const indicatorStyle = computed(() => {
  const numOptions = props.options.length
  const padding = 6 // p-1.5 = 6px
  const gap = 4 // gap-1 = 4px
  const totalGaps = (numOptions - 1) * gap
  const width = `calc((100% - ${padding * 2}px - ${totalGaps}px) / ${numOptions})`
  const left = `calc(${padding}px + ((100% - ${padding * 2}px - ${totalGaps}px) / ${numOptions} + ${gap}px) * ${selectedIndex.value})`

  return {
    width,
    left,
  }
})
  
const selectOption = (index) => {
  const selectedOption = props.options[index]
  model.value = selectedOption.value
  emit('change', selectedOption)
}

defineExpose({
  selectedIndex,
  selectOption
})
</script>